import React from "react";
//#region types
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { StaticInfoMessage } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const RevenueReportingDifference: React.FC = () => (
  <div className={cssExports.revenueReportingDifference}>
    <StaticInfoMessage displayType={StyleEnums.DisplayType.Warning} gutterBottom>
      {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.RevenueReporting.DifferenceWarningText)}
    </StaticInfoMessage>
  </div>
);

export default RevenueReportingDifference;
